import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './customer-account.reducer';

export const CustomerAccountDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const customerAccountEntity = useAppSelector(state => state.customerAccount.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="customerAccountDetailsHeading">
          <Translate contentKey="crawlerBackendApp.customerAccount.detail.title">CustomerAccount</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{customerAccountEntity.id}</dd>
          <dt>
            <span id="isContact">
              <Translate contentKey="crawlerBackendApp.customerAccount.isContact">Is Contact</Translate>
            </span>
          </dt>
          <dd>{customerAccountEntity.isContact ? 'true' : 'false'}</dd>
          <dt>
            <span id="collectiveInvoice">
              <Translate contentKey="crawlerBackendApp.customerAccount.collectiveInvoice">Collective Invoice</Translate>
            </span>
          </dt>
          <dd>{customerAccountEntity.collectiveInvoice ? 'true' : 'false'}</dd>
          <dt>
            <Translate contentKey="crawlerBackendApp.customerAccount.billingAddress">Billing Address</Translate>
          </dt>
          <dd>{customerAccountEntity.billingAddress ? customerAccountEntity.billingAddress.id : ''}</dd>
          <dt>
            <Translate contentKey="crawlerBackendApp.customerAccount.bankAccount">Bank Account</Translate>
          </dt>
          <dd>{customerAccountEntity.bankAccount ? customerAccountEntity.bankAccount.id : ''}</dd>
          <dt>
            <Translate contentKey="crawlerBackendApp.customerAccount.contractHolder">Contract Holder</Translate>
          </dt>
          <dd>{customerAccountEntity.contractHolder ? customerAccountEntity.contractHolder.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/customer-account" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/customer-account/${customerAccountEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default CustomerAccountDetail;
